export default __webpack_public_path__ + "static/article-finance-4-questions-658974132fae4606f5ea76ded888f6fc.jpg";